export const count = state => state.count;
export const menu = state => state.menu;



// WEBPACK FOOTER //
// ./G:/tmp/vue1/src/vuex/getters.js